// UI constants shared across components
export const STICKY_SCROLL_THRESHOLD = 200; // px

